import { VISOR_MODULE_BREADCRUMB_ROOT } from "@/modules/workModuleCore";
import { PageHeader } from "./layoutChrome";
import SatSyncDashboard from "@/components/SatSyncDashboard";
import SatRobotControlPanel from "@/components/disenador/SatRobotControlPanel";
import { useSatMonitorTechnicalAccess } from "@/lib/satMonitorTechnicalAccess";
import { useLocation } from "react-router-dom";
import { resolveDatosMaestrosAwareBreadcrumb } from "@/modules/datosMaestros/datosMaestrosNavigation";
import { useDatosMaestrosNavigationContext } from "@/modules/datosMaestros/useDatosMaestrosNavigationContext";

/**
 * Monitor de sincronización automática SAT (Fase 2) — pantalla dedicada.
 */
export default function MonitorSincronizacionSat() {
  const location = useLocation();
  useDatosMaestrosNavigationContext();
  const showTechnicalActions = useSatMonitorTechnicalAccess();

  return (
    <div className="min-h-screen">
      <PageHeader
        title="Monitor de sincronización SAT"
        subtitle="Estado del worker nocturno: éxitos, errores y reintentos por RFC."
        breadcrumb={resolveDatosMaestrosAwareBreadcrumb(
          location,
          VISOR_MODULE_BREADCRUMB_ROOT,
          "Monitor de sincronización",
        )}
      />
      <div className="p-8 space-y-5 max-w-7xl mx-auto">
        {showTechnicalActions ? <SatRobotControlPanel /> : null}
        <div className="bg-white rounded-md border border-slate-200 p-5 shadow-sm">
          <SatSyncDashboard showTechnicalActions={showTechnicalActions} />
        </div>
      </div>
    </div>
  );
}
